import { FunctionComponent } from "react";

export interface RadioButtonProps {
  isActive: boolean | undefined | null;
  label: string;
  error?: boolean;
  errorText?: string;
  setValue: () => void;
}

const RadioButton: FunctionComponent<RadioButtonProps> = ({
  isActive,
  setValue,
  label,
}) => {
  return (
    <div
      className={`btn small ${
        isActive ? "btn-outline-active" : "btn-outline"
      } text-center`}
      onClick={() => setValue()}
    >
      <label className="text-left cursor-pointer">
        <input
          type="radio"
          className="hidden"
          checked={!!isActive}
          onChange={() => setValue()}
        />
        <span>{label}</span>
      </label>
    </div>
  );
};

export default RadioButton;
